var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-helper"},[_c('div',{staticClass:"btn-box"},[_c('a-button',{staticClass:"btn",attrs:{"disabled":_vm.preDisabled},on:{"click":_vm.handlePrevious}},[_vm._v("上一页")]),_c('a-button',{staticClass:"btn",attrs:{"disabled":_vm.nextDisabled},on:{"click":_vm.handleNext}},[_vm._v("下一页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }